// AiLys partner portal app entry. Phase 6.1 Chunk d wires routing.
//
// Routes (Chunks d through h):
// - /login (Chunk d) - public
// - /dashboard (Chunk e) - protected, role-aware
// - /clients, /clients/:id (Chunk f) - partner_owner+
// - /commissions (Chunk g) - partner_owner+
// - /settings (Chunk h) - partner_owner+
//
// Phase 6.1 Chunk d ships /login + the AuthGate wrapper. Other routes
// land empty placeholders that ship full content in subsequent chunks.

import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import { LangProvider } from './i18n';
import { ToastProvider } from './components/ui';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Commissions from './pages/Commissions';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import Team from './pages/Team';
import Training from './pages/Training';
import TrainingModule from './pages/TrainingModule';
import WhiteLabel from './pages/WhiteLabel';
import { AuthGate } from './components/AuthGate';

function LoginRoute() {
  const [params] = useSearchParams();
  return <Login next={params.get('next') ?? undefined} />;
}

function ProtectedPlaceholder({ title }: { title: string }) {
  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: '#0a0e1a',
        color: '#e2e8f0',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            fontFamily: 'monospace',
            fontSize: '10px',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: '#67e8f9',
            marginBottom: '12px',
          }}
        >
          AiLys Partner Portal
        </div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 600, margin: '0 0 12px' }}>
          {title}
        </h1>
        <p style={{ fontSize: '0.85rem', color: '#94a3b8' }}>
          Surface ships in a later Phase 6.1 chunk. Stay tuned.
        </p>
        <p style={{ marginTop: '24px' }}>
          <a
            href="/api/auth/logout"
            style={{
              fontSize: '0.85rem',
              color: '#94a3b8',
              textDecoration: 'underline',
            }}
          >
            Sign out
          </a>
        </p>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <LangProvider>
    <ToastProvider>
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <AuthGate>
              <Dashboard />
            </AuthGate>
          }
        />
        <Route path="/login" element={<LoginRoute />} />
        <Route
          path="/dashboard"
          element={
            <AuthGate>
              <Dashboard />
            </AuthGate>
          }
        />
        <Route
          path="/clients"
          element={
            <AuthGate>
              <Clients />
            </AuthGate>
          }
        />
        <Route
          path="/clients/:id"
          element={
            <AuthGate>
              <ClientDetail />
            </AuthGate>
          }
        />
        <Route
          path="/commissions"
          element={
            <AuthGate>
              <Commissions />
            </AuthGate>
          }
        />
        <Route
          path="/settings"
          element={
            <AuthGate>
              <Settings />
            </AuthGate>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthGate>
              <Profile />
            </AuthGate>
          }
        />
        <Route
          path="/team"
          element={
            <AuthGate>
              <Team />
            </AuthGate>
          }
        />
        <Route
          path="/training"
          element={
            <AuthGate>
              <Training />
            </AuthGate>
          }
        />
        <Route
          path="/training/:slug"
          element={
            <AuthGate>
              <TrainingModule />
            </AuthGate>
          }
        />
        <Route
          path="/white-label"
          element={
            <AuthGate>
              <WhiteLabel />
            </AuthGate>
          }
        />
        <Route path="*" element={<ProtectedPlaceholder title="404 not found" />} />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </LangProvider>
  );
}
